import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../services/mygreencountry/auth.service";

@Component({
  selector: 'app-page404',
  templateUrl: './page404.page.html',
  styleUrls: ['./page404.page.scss'],
})
export class Page404Page implements OnInit {


    isItParent: boolean = false;
    isItStudent: boolean = false;

  constructor(private authService: AuthService,) { }

  ngOnInit() {

      if(this.authService.isStudent()){
          this.isItStudent =true;
      }else{
          this.isItParent =true;
      }

  }

}
